exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-selector-container {\n  height: 45px; }\n  .top-selector-container:before {\n    background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0.33, white), color-stop(0.97, #d7d7d7));\n    content: \"\";\n    position: absolute;\n    height: 10px;\n    width: 100%;\n    top: 0; }\n  .top-selector-container i {\n    font-size: 24px;\n    padding-right: 16px; }\n\n.top-selector-bottom-border {\n  border-bottom: 2px solid #D7D7D7; }\n\n.tab-content {\n  margin: auto; }\n\n.contact-name {\n  margin-top: .6rem; }\n\n.mat-row {\n  height: 58px; }\n\n.selectedView {\n  color: #4b81b0 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/colaboradores/colaboradores-list/colaboradores-list.component.scss
// module id = ../../../../../src/app/components/abm/colaboradores/colaboradores-list/colaboradores-list.component.scss
// module chunks = 0